import { EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import React from 'react';
import { EntityContentWrapper, EntityTeamCard } from '../../../components/catalog';
import { EntityGroupProfileCard, EntityOwnershipCard } from '@backstage/plugin-org';

const OverviewContent = () => {
  return (
    <EntityContentWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <EntityGroupProfileCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <EntityOwnershipCard />
        </Grid>
        <Grid item xs={12} md={12}>
          <EntityTeamCard />
        </Grid>
      </Grid>
    </EntityContentWrapper>
  );
};

export const GroupPage = () => {
  return (
    <EntityLayout UNSTABLE_contextMenuOptions={{ disableUnregister: 'hidden' }}>
      <EntityLayout.Route path="/" title="Overview">
        <OverviewContent />
      </EntityLayout.Route>
    </EntityLayout>
  );
};
